import React from "react";
import { type TotalBalanceCardProps } from "utils/types/wallet.type";

export default function TotalBalanceCard({
  totalBalanceInUsd,
}: TotalBalanceCardProps) {
  return (
    <div className="mb-4 p-4 bg-cyan-100 rounded-lg">
      <p className="text-black-800 text-sm mb-1">Total Balance</p>
      <p className="text-black-900 text-2xl font-bold">
        ${totalBalanceInUsd.toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}
      </p>
    </div>
  );
}

